<script>
  let { children } = $props();
</script>

{@render children()}
